"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
var globalDataGetters_1 = require("../globalDataGetters");
var mapPageData = function (page) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var mappedPageData = {
        pageInfo: {
            pageName: ((_a = page === null || page === void 0 ? void 0 : page.pageInfo) === null || _a === void 0 ? void 0 : _a.pageName)
                ? decodeURIComponent((0, utils_1.removeSpecialCharacters)(page.pageInfo.pageName))
                : (0, globalDataGetters_1.getPageName)(),
            langcountry: ((_b = page === null || page === void 0 ? void 0 : page.pageInfo) === null || _b === void 0 ? void 0 : _b.langCountry)
                ? (0, utils_1.removeSpecialCharacters)(page.pageInfo.langCountry)
                : (0, globalDataGetters_1.getLangCountry)(true),
            siteName: ((_c = page === null || page === void 0 ? void 0 : page.pageInfo) === null || _c === void 0 ? void 0 : _c.siteName)
                ? (0, utils_1.removeSpecialCharacters)(page.pageInfo.siteName)
                : (0, globalDataGetters_1.getSiteName)().toLowerCase(),
            server: ((_d = page === null || page === void 0 ? void 0 : page.pageInfo) === null || _d === void 0 ? void 0 : _d.server)
                ? (0, utils_1.removeSpecialCharacters)(page.pageInfo.server)
                : (0, globalDataGetters_1.getServerName)(),
        },
        category: {
            siteSection: ((_e = page === null || page === void 0 ? void 0 : page.category) === null || _e === void 0 ? void 0 : _e.siteSection)
                ? decodeURIComponent((0, utils_1.removeSpecialCharacters)(page.category.siteSection))
                : decodeURIComponent((0, globalDataGetters_1.getSiteSection)()),
            siteSectionLevel2: ((_f = page === null || page === void 0 ? void 0 : page.category) === null || _f === void 0 ? void 0 : _f.siteSectionLevel2)
                ? decodeURIComponent((0, utils_1.removeSpecialCharacters)(page.category.siteSectionLevel2))
                : (0, globalDataGetters_1.getSiteSectionLevel2)() !== ""
                    ? decodeURIComponent((0, globalDataGetters_1.getSiteSectionLevel2)())
                    : "not-available",
            siteSectionLevel3: ((_g = page === null || page === void 0 ? void 0 : page.category) === null || _g === void 0 ? void 0 : _g.siteSectionLevel3)
                ? decodeURIComponent((0, utils_1.removeSpecialCharacters)(page.category.siteSectionLevel3))
                : (0, globalDataGetters_1.getSiteSectionLevel3)() !== ""
                    ? decodeURIComponent((0, globalDataGetters_1.getSiteSectionLevel3)())
                    : "not-available",
            hier1: ((_h = page === null || page === void 0 ? void 0 : page.category) === null || _h === void 0 ? void 0 : _h.hier1)
                ? decodeURIComponent((0, utils_1.removeSpecialCharacters)(page.category.hier1))
                : decodeURIComponent((0, globalDataGetters_1.getAllHier1)()),
        },
    };
    return mappedPageData;
};
exports.default = mapPageData;
